import React, { useState, useEffect, useRef } from 'react';
import { Link,} from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll';
import Select from 'react-select';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { getTokenInfo } from '../../../UseToken';
//import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

//import { List, arrayMove } from "react-movable";;

import {
	reqGET,
	reqPOST,
	//reqDELETE,
	reqPUT,
	reqFILE,
	repo_banner_link,
	//content_language,
} from '../../../Utils';
import Hosts from '../../../Hosts';

import { language } from './Language';
//import { reduce } from 'core-js/core/array';

import Main from '../../Main/Init'

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [data_trainees, set_data_trainees] = useState([]);

	//const [dados2, set_dados_2] = useState('');

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);

	const [refresh, setRefresh] = useState(0);
	
	//const [isRedirect, setRedirect] = useState(false);

	//const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)

	//const add_trainers_permission = ('Administrador' === getTokenInfo().profile || 'Gestor de formações' === getTokenInfo().profile || 'Coordenador de formações' === getTokenInfo().profile);

	const [/*editorLoaded*/, setEditorLoaded] = useState(false);

	const [aTypes, ] = useState(['pdf'])

	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);
	
	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				//console.log(res.data[0])
			})
			.catch(error => console.log(error))
	}

	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}


	useEffect(() => {
		//setEditorLoaded(true);
		get_trainers();
		clean_data();

		set_lang(localStorage.getItem('lang'))


		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				//set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id'])
					.then(() => {

						if(/*getTokenInfo().profile === 'Gestor de formações' ||*/ getTokenInfo().profile === 'Administrador') {

							reqGET(`${Hosts.SIMCore_API}/entities/list/${Hosts.companycode}/trainee_user`)
								.then(res => { 

									//console.log('ARRAY FORMANDOS', res.data)
					
									set_data_trainees(res.data)
								})
								.catch(erro => console.log('Erro entidades', erro))
				
						}

						setLoading(false)
						setEditorLoaded(true);
					})
				return			
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}
	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					dados.current.info.date.modified.push(today_submit)

					files_doc.forEach(async (el_doc) => {
						// console.log(el_doc)  
						if (el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, el_doc.uid, 'doc')
						}
					})
					set_files_doc([])
					set_files_doc_name([])

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
							setRefresh(r => r +1)
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit
					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/formation/course/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									//console.log(res.data)
									dados.current.id = res.data[0].id

									set_is_edit(true)
									//set_show_delete_button(true)
								})
								.catch(() => 404)

							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	/*function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				remove_content_from_menu(dados.current.id)

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => {
						
						props.history.push(endpoints.list);

					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};*/

	/*const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_content_nolang = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.content[0][name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_info_select = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name]['id'] = value)
		set_dados(dados.current.info[name]['name'] = '')
	}*/


	// TRAINER
	const [trainers, set_trainers] = useState([]);
	const [trainer_selected, set_selected_trainer] = useState({label: '', value: '', email:'', username: ''})
	const get_trainers = async () => {
		let aTrainers = [];

		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/trainer_user`)
			.then(res => {
				res.data.forEach(v => {

					//console.log(v)
					aTrainers.push({ label: v.name + ' ' + v.surname, value: v.id, email: v.email, username: v.username })
				});					

				set_trainers(aTrainers)
			})
			.catch( erro => { console.log( erro ) ; } )
	}

	const add_trainer = () => {
		
		let trainer = trainers.filter(v => v.label === trainer_selected.label);
		

		if(trainer.length === 0) {

		}
		else {

			if(dados.current.info['trainers'] === undefined)
				dados.current.info['trainers'] = []

			dados.current.info.trainers.forEach(v => {

				if(v.id === trainer_selected.value){
					//alert('este formador já foi adicionado a esta formação')
					Swal.fire(language[lang].add_trainer, language[lang].add_trainer_error, 'error')
					set_selected_trainer({label: '', value: '', email:'', username:'' })
					trainer = [];
				}
			});

			
			if(trainer.length !== 0){
				set_dados(dados.current.info.trainers.push(
					{ 
						email: trainer_selected.email,
						id:  trainer_selected.value,
						name: trainer_selected.label,
						notified: false,
						username: trainer_selected.username,
						
					}
				));
			}

			// console.log('Dados Add Trainer:' + JSON.stringify(dados))
		}
	

		set_selected_trainer({label: '', value: '', email:'', username:'' })
	}

	const removeInputTrainer = (index) => {
		
		let del_value = dados.current.info.trainers.slice(index, index + 1);
		//console.log('TESTE REMOVE', dados.current.info.trainers)
		let trainers = dados.current.info.trainers.filter(v => v.id !== del_value[0].id);

		set_dados(dados.current.info.trainers = trainers)

	};

	const handle_selected_trainers = (e) => {


		//console.log('selected value', e)
		const { label, value, email, username } = e;
		
		set_selected_trainer({label: label, value: value, email: email, username: username })
	}


	/* TRAINEES/CANDIDATES */

	const handle_change_candidates = async (e) => {
		const { name, value, dataset } = e.target;
		const { index, trainee_id, trainee_name, trainee_email } = dataset;

		// console.log(trainee_id)
		// console.log(trainee_name)
		// console.log(trainee_email)

		// await get_data_trainees(trainee_id)
		//	.then((res) => {

				// console.log('DADOS FORMANDO', res)

				if(value === 'accepted') {

					let data = new Date().toJSON()
		
					if(dados.current.content[0]['trainees'] === undefined)
						dados.current.content[0]['trainees'] = []
		
					if(dados.current.content[0].trainees.length > 0){
						dados.current.content[0].trainees = dados.current.content[0].trainees.filter(v => v.trainee_id !== trainee_id);
					}
				
					dados.current.content[0].trainees.push(
						{ 
							trainee_id: trainee_id,
							trainee_name: trainee_name,
							trainee_email: trainee_email,
							trainee_status: '',
							//trainee_status: 'accepted',
							trainee_accepted_date: data,
							
						}
					);
		
					if(dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0) {
		
						dados.current.content[0].modules.forEach(v => {
		
							if(v['trainees'] === undefined)
								v['trainees'] = []
		
							if(v.trainees.length > 0){
								v.trainees = v.trainees.filter(v2 => v2.trainee_id !== trainee_id);
							}
		
							v.trainees.push(
								{ 
									trainee_id: trainee_id,
									trainee_name: trainee_name,
									trainee_email: trainee_email,
									trainee_accepted_date: data
								}
							);
		
							if(v.sessions !== undefined && v.sessions.length > 0) { 
		
								v.sessions.forEach(v2 => { 
		
									if(v2['trainees'] === undefined)
										v2['trainees'] = []
		
									if(v2.trainees.length > 0){
										v2.trainees = v2.trainees.filter(v3 => v3.trainee_id !== trainee_id);
									}
		
									v2.trainees.push(
										{ 
											trainee_id: trainee_id,
											trainee_name: trainee_name,
											trainee_email: trainee_email,
											trainee_session_attendance: false,
											trainee_accepted_date: data
										}
									);
		
								});
		
		
							}
						});
					}
		
				}
				else {
		
					if(dados.current.content[0]['trainees'] !== undefined && dados.current.content[0].trainees.length > 0){
						dados.current.content[0].trainees = dados.current.content[0].trainees.filter(v => v.trainee_id !== trainee_id);
					}
		
					if(dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0) {
		
						dados.current.content[0].modules.forEach(v => {
		
							if(v['trainees'] !== undefined && v.trainees.length > 0){
								v.trainees = v.trainees.filter(v2 => v2.trainee_id !== trainee_id);
							}
		
							if(v.sessions !== undefined && v.sessions.length > 0) { 
		
								v.sessions.forEach(v2 => { 
		
									if(v2['trainees'] !== undefined && v2.trainees.length > 0){
										v2.trainees = v2.trainees.filter(v3 => v3.trainee_id !== trainee_id);
									}
		
								});
		
		
							}
						});
					}

				}

		// 	})

		if(name === 'trainee_rejection_reason'){ 

			if(dados.current.content[0]['candidates'][index][name] === undefined)
				dados.current.content[0]['candidates'][index][name] = ''

		}

		set_dados(dados.current.content[0]['candidates'][index][name] = value)

		setRefresh(refresh + 1)
		
		
		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current CANDIDATE && MODULES_TRAINEES:' + JSON.stringify(dados))
	}

	const get_data_trainees = async (id) => {
    
		return await reqGET(`${api_crud_base}/entities/${getTokenInfo().companycode}/${id}`)
			.then(res => {

				//set_dados_2(res.data[0]);
				return res.data[0]

				//console.log(res.data[0])
				//console.log(res.data[0].info.courses.length)

			})
			.catch( erro => { console.log( erro ) ; /*alert( 'Erro' );*/ } )
	}

	function notifyCandidateAndSaveTrainee(trainee_id, trainee_name, trainee_email, trainee_status, trainee_rejection_reason, index) {

		if(trainee_status === 'rejected' && trainee_rejection_reason === ''){

			Swal.fire({
				title: language[lang].trainee_notify,
				html: language[lang].trainee_notify_error_button,
				icon: 'warning'
			})


		}else {

			Swal.fire({
				title: language[lang].trainee_notify,
				html: language[lang].trainee_notify_confirm_text1  + '<b>' + trainee_name + '</b>' + language[lang].trainee_notify_confirm_text2 + '<b>' + dados.current.content[0].title + '.</b></br>' + language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})

			//Swal.fire(language[lang].regist, language[lang].regist_text, 'success')

			.then((result) => {
				if (result.isConfirmed) {

					let data = new Date().toJSON()
					//let aDate = [data];

					dados.current.content[0]['candidates'][index]['trainee_response_date'] = data
					dados.current.content[0]['candidates'][index]['trainee_notified'] = true

					/*if(trainee_status === 'accepted') {

						if(dados.current.content[0]['trainees'] === undefined)
							dados.current.content[0]['trainees'] = []

						if(dados.current.content[0].trainees.length > 0){
							dados.current.content[0].trainees = dados.current.content[0].trainees.filter(v => v.trainee_id !== trainee_id);
						}
					
						dados.current.content[0].trainees.push(
							{ 
								trainee_id: trainee_id,
								trainee_name: trainee_name,
								trainee_email: trainee_email,
								trainee_status: 'accepted',
								trainee_accepted_date: data
							}
						);

					}*/

					reqPUT(api_crud_route, dados.current)
						.then(() => {

							get_data_trainees(trainee_id)
								.then((res) => {

									let data_aux = {
										files: res.info.files,
										qualifications: res.info.qualifications,
										employment: res.info.employment,
										status: trainee_status,
										date: data,
									}
									if(dados.current.content[0]['candidates'][index]['candidate_data'] === undefined)
										dados.current.content[0]['candidates'][index]['candidate_data'] = []
					
									dados.current.content[0]['candidates'][index]['candidate_data'].push(data_aux)
									
									reqPUT(api_crud_route, dados.current)
										.then(() => {})
										.catch(() => {})


									res.info.courses.forEach(v => {
										if(v.course_id === dados.current.id) {

											v.request_status = trainee_status

											/*if(v['request_response'] === undefined)
												v['request_response'] = ''*/
											v['request_response_date'] = data
										}
									})

									reqPUT(api_crud_base + '/entities/', res)
										.then(() => {

											let mailOptions = {
												from: Hosts.contactFrom,
												// vários emails separados por virgulas
												to: trainee_email,
											
												//cc-> opcional
												//cc: Hosts.contactFrom,
												subject: Hosts.webSiteTitle + ' - ' + language[lang].trainee_notify,
												//text: 'Teste de EMAIL ', -> opcional
												html: 
												'<html><head></head><body style="background-color:#F7F7F7;">' +
													'<div style="width:100% !important;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;color:#425968;background-color:#F7F7F7;background-image:none;background-repeat:repeat;background-position:top left;background-attachment:scroll;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;">' +
													'<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-collapse:collapse;">' +
														'<tr style="border-collapse: collapse;">' +
														'<td style="border-collapse: collapse;">' +
															'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
															'<tr style="border-collapse: collapse;">' +
																'<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
																'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
																	'<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
																'</a>'+
																'</td>' +
															'</tr>' +
															'</table>' +
															'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
															'<tr style="border-collapse: collapse;">' +
																'<td align="left" class style="margin: 0 auto; padding: 15px 30px; border-collapse:collapse;">' +
																'<div>'+
																	'<h4 style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;">'+ language[lang].trainee_notify +':</h4>'+
																	'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">' + language[lang].hello + ', ' + trainee_name + '.</span>' +
																	'<br/>'+
																	'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].trainee_notify_email_text1 + '<b><label>' + dados.current.content[0].title + '</label></b>'+ language[lang].trainee_notify_email_text2 + '<b>' + language[lang][trainee_status] + '.</b></span>'+
																	'<br/>'+
																	'<br/>'+
																	'<span style="' + ((trainee_status === 'rejected') ? 'display: block;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;' : 'display: none') + '"><b>'+ language[lang].rejected_reason_label +': </b>'+ trainee_rejection_reason + '</br></br></span>'+
																	'<span style="' + ((trainee_status === 'accepted') ? 'display: block;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;' : 'display: none') + '">'+ language[lang].trainee_notify_email_text3 + '</span>'+
																	'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+  language[lang].trainee_notify_email_text4 + '</span>'+
																	'<br/>'+
																	'<br/>'+
																	'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_BACKOFFICE_URL + '" target="_blank" style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].access_app +'</a>'+
																	'<br/>'+
																'</div>'+
																'</td>' +
															'</tr>' +
															'</table>' +
															'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:' + Hosts.FOOTER_EMAIL_COLOR +'; padding: 10px; border:1px solid transparent;border-collapse:collapse;">' +
															'<tr style="border-collapse: collapse;">' +
																'<td align="left" style="padding:10px 0px; border-collapse:collapse;">' +
																'<div style="margin: 0 auto; width:600px;">'+
																	'<div style="text-align: center; font-size: small; color: #FFFFFF;">'+
																	'<span style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteTitle + '</span>'+
																	'<br/>'+
																	'<span style="font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteAdress + '</span>'+
																	'<br/>'+
																	'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_BACKOFFICE_URL + '" target="_blank" style="font-family:Arial,Helvetica,sans-serif;text-decoration:none;"> '+
																		'<span style="color: #FFFFFF;font-family:Arial,Helvetica,sans-serif;font-size:12px;" >'+ Hosts.EMAIL_WEB_BACKOFFICE_URL +'</span>' +
																	'</a>'+
																	'</div>'+
																'</div>' +
																'</td>' +
															'</tr>' +
															'</table>' +
														'</td>' +
														'</tr>' +
													'</table>' +
													'</div>' +
												'<body><html>',
												//attachments -> opcional 
												// attachments: [     
												// 	{   // encoded string em Base 64
												// 	filename: 'text1.txt',
												// 	content: 'aGVsbG8gd29ybGQh',
												// 	encoding: 'base64'
												// 	},
												// ]
											
												};

											reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
												.then(() => { 
													Swal.fire({
														title: language[lang].trainee_notify,
														html: language[lang].trainee_notify_success,
														icon: 'success'
													})
													setRefresh(refresh + 1)
												})
												.catch((error) => { 
													Swal.fire(language[lang].trainee_notify_error, '', 'info')
													console.log('ERROR SENDING EMAIL TO TRAINEE/CANDIDATE: ', error)
												})
											
											/*Swal.fire({
												title: language[lang].trainee_notify,
												html: language[lang].trainee_notify_success,
												icon: 'success'
											})*/
											//props.history.push('/courses_list');
					
										})
										.catch((error) => { 
											Swal.fire(language[lang].trainee_notify_error, '', 'info')
											console.log('ERROR UPDATING TRAINEE/CANDIDATE DATA: ', error)
										})

								})

						})
						.catch((error) => { 
							Swal.fire(language[lang].trainee_notify_error, '', 'info')
							console.log('ERROR UPDATING FORMATION DATA: ', error)
						})
				}
			})
		}
	};

	const removeInputCandidate = (index) => {
		
		let del_value = dados.current.content[0].candidates.slice(index, index + 1);
		//console.log('TESTE REMOVE', dados.current.content[0].candidates)
		let candidates = dados.current.content[0].candidates.filter(v => v.trainee_id !== del_value[0].trainee_id);

		set_dados(dados.current.content[0].candidates = candidates)

	};

	const handle_change_trainees = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.content[0]['trainees'][index][name] = value)
		
		
		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current TRAINEES:' + JSON.stringify(dados))
	}

	function notifyAndSaveTrainee(trainee_id, trainee_name, trainee_email) {

		Swal.fire({
			title: language[lang].trainee_notify,
			html: language[lang].trainee_notify_confirm_text1  + '<b>' + trainee_name + '</b>' + language[lang].trainee_notify_confirm_text3 + '<b>' + dados.current.content[0].title + '.</b></br>' + language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})

		.then((result) => {
			if (result.isConfirmed) {

				let data = new Date().toJSON()

				if(dados.current.content[0]['trainees'] === undefined)
					dados.current.content[0]['trainees'] = []

				if(dados.current.content[0].trainees.length > 0){
					dados.current.content[0].trainees = dados.current.content[0].trainees.filter(v => v.trainee_id !== trainee_id);
				}
			
				dados.current.content[0].trainees.push(
					{ 
						trainee_id: trainee_id,
						trainee_name: trainee_name,
						trainee_email: trainee_email,
						trainee_status: '',
						trainee_accepted_date: data
					}
				);

				if(dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0) {
		
					dados.current.content[0].modules.forEach(v => {
	
						if(v['trainees'] === undefined)
							v['trainees'] = []
	
						if(v.trainees.length > 0){
							v.trainees = v.trainees.filter(v2 => v2.trainee_id !== trainee_id);
						}
	
						v.trainees.push(
							{ 
								trainee_id: trainee_id,
								trainee_name: trainee_name,
								trainee_email: trainee_email,
								trainee_accepted_date: data
							}
						);
	
						if(v.sessions !== undefined && v.sessions.length > 0) { 
	
							v.sessions.forEach(v2 => { 
	
								if(v2['trainees'] === undefined)
									v2['trainees'] = []
	
								if(v2.trainees.length > 0){
									v2.trainees = v2.trainees.filter(v3 => v3.trainee_id !== trainee_id);
								}
	
								v2.trainees.push(
									{ 
										trainee_id: trainee_id,
										trainee_name: trainee_name,
										trainee_email: trainee_email,
										trainee_session_attendance: false,
										trainee_accepted_date: data
									}
								);
	
							});
	
	
						}
					});
				}

				//setRefresh(refresh + 1)

				reqPUT(api_crud_route, dados.current)
					.then(() => {

						let aux_data_inicio = ''
						if(dados.current.info.date.begin !== undefined && dados.current.info.date.begin !== '') {
							aux_data_inicio = dados.current.info.date.begin.split('T')[0]
						}

						let mailOptions = {
							from: Hosts.contactFrom,
							// vários emails separados por virgulas
							to: trainee_email,
						
							//cc-> opcional
							//cc: Hosts.contactFrom,
							subject: Hosts.webSiteTitle + ' - ' + language[lang].trainee_notify,
							//text: 'Teste de EMAIL ', -> opcional
							html: 
							'<html><head></head><body style="background-color:#F7F7F7;">' +
								'<div style="width:100% !important;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;color:#425968;background-color:#F7F7F7;background-image:none;background-repeat:repeat;background-position:top left;background-attachment:scroll;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;">' +
								'<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-collapse:collapse;">' +
									'<tr style="border-collapse: collapse;">' +
									'<td style="border-collapse: collapse;">' +
										'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
										'<tr style="border-collapse: collapse;">' +
											'<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
											'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
												'<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
											'</a>'+
											'</td>' +
										'</tr>' +
										'</table>' +
										'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
										'<tr style="border-collapse: collapse;">' +
											'<td align="left" class style="margin: 0 auto; padding: 15px 30px; border-collapse:collapse;">' +
											'<div>'+
												'<h4 style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;">'+ language[lang].trainee_notify +':</h4>'+
												'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">' + language[lang].hello + ', ' + trainee_name + '.</span>' +
												'<br/>'+
												'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].trainee_notify_email_text5 + '<b>' + dados.current.content[0].title + '</b>' + language[lang].trainee_notify_email_text6 + '<b>'+ aux_data_inicio + '</b>.</span>'+
												'<br/>'+
												'<br/>'+
												//'<span style="' + ((trainee_status === 'rejected') ? 'display: block;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;' : 'display: none') + '"><b>'+ language[lang].rejected_reason_label +': </b>'+ trainee_rejection_reason + '</br></br></span>'+
												//'<span style="' + ((trainee_status === 'accepted') ? 'display: block;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;' : 'display: none') + '">'+ language[lang].trainee_notify_email_text3 + '</span>'+
												'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+  language[lang].trainee_notify_email_text4 + '</span>'+
												'<br/>'+
												'<br/>'+
												'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_BACKOFFICE_URL + '" target="_blank" style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].access_app +'</a>'+
												'<br/>'+
											'</div>'+
											'</td>' +
										'</tr>' +
										'</table>' +
										'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:' + Hosts.FOOTER_EMAIL_COLOR +'; padding: 10px; border:1px solid transparent;border-collapse:collapse;">' +
										'<tr style="border-collapse: collapse;">' +
											'<td align="left" style="padding:10px 0px; border-collapse:collapse;">' +
											'<div style="margin: 0 auto; width:600px;">'+
												'<div style="text-align: center; font-size: small; color: #FFFFFF;">'+
												'<span style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteTitle + '</span>'+
												'<br/>'+
												'<span style="font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteAdress + '</span>'+
												'<br/>'+
												'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_BACKOFFICE_URL + '" target="_blank" style="font-family:Arial,Helvetica,sans-serif;text-decoration:none;"> '+
													'<span style="color: #FFFFFF;font-family:Arial,Helvetica,sans-serif;font-size:12px;" >'+ Hosts.EMAIL_WEB_BACKOFFICE_URL +'</span>' +
												'</a>'+
												'</div>'+
											'</div>' +
											'</td>' +
										'</tr>' +
										'</table>' +
									'</td>' +
									'</tr>' +
								'</table>' +
								'</div>' +
							'<body><html>',
							//attachments -> opcional 
							// attachments: [     
							// 	{   // encoded string em Base 64
							// 	filename: 'text1.txt',
							// 	content: 'aGVsbG8gd29ybGQh',
							// 	encoding: 'base64'
							// 	},
							// ]
						
							};

						reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
							.then(() => { 
								Swal.fire({
									title: language[lang].trainee_notify,
									html: language[lang].trainee_notify_success,
									icon: 'success'
								})
								setRefresh(refresh + 1)
							})
							.catch((error) => { 
								Swal.fire(language[lang].trainee_notify_error, '', 'info')
								console.log('ERROR SENDING EMAIL TO TRAINEE/CANDIDATE: ', error)
							})
					})
					.catch((error) => { 
						Swal.fire(language[lang].trainee_notify_error, '', 'info')
						console.log('ERROR UPDATING FORMATION DATA: ', error)
					})
			}
		})
		
	};
	
	/* MODULES TRAINER */

	//const [module_trainer, set_module_trainer] = useState({});

	const handle_change_module_trainer = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		//console.log(JSON.parse(value))

		//console.log(value)

		if(value !== '---'){
			let trainer = JSON.parse(value)
			
			if(dados.current.content[0]['modules'][index][name] === undefined){ 
				dados.current.content[0]['modules'][index][name] = {}
			}

			//set_dados(dados.current.content[0]['modules'][index][name] = value)

			dados.current.content[0]['modules'][index][name] = 
				{ 
					email: trainer.email,
					id:  trainer.id,
					name: trainer.name,
					notified: false,
					username: trainer.username
					
				}
		}
		else{

			dados.current.content[0]['modules'][index][name] = 
				{ 
					email: '',
					id:  '',
					name: '',
					notified: false,
					username: ''
					
				}

		}

		/*set_module_trainer(
			{
				id:  trainer.id,
				name: trainer.name,
				email: trainer.email,
				notified: false,
				username: trainer.username 
			}
		)*/

		setRefresh(refresh + 1)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current MODULE TRAINER:' + JSON.stringify(dados))
	}

	function notifyTrainerAndSave(trainer_id, trainer_name, trainer_email, module_name, index) {

		if(trainer_id !== '') {
		

			Swal.fire({
				title: language[lang].trainer_notify,
				html: language[lang].trainer_notify_confirm_text1  + '<b>' + trainer_name + '</b>' + language[lang].trainer_notify_confirm_text2 + '<b>' + module_name + '</b>' + language[lang].trainer_notify_confirm_text3 + '<b>' + dados.current.content[0].title + '.</b></br>' + language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})

			//Swal.fire(language[lang].regist, language[lang].regist_text, 'success')

			.then((result) => {
				if (result.isConfirmed) {

					//let data = new Date();
					//let aDate = [data];
				
					dados.current.content[0]['modules'][index]['trainer']['notified'] = true

					reqPUT(api_crud_route, dados.current)
						.then(() => {

							let aux_data_inicio = ''
							if(dados.current.info.date.begin !== undefined && dados.current.info.date.begin !== '') {
								aux_data_inicio = dados.current.info.date.begin.split('T')[0]
							}

							let mailOptions = {
								from: Hosts.contactFrom,
								// vários emails separados por virgulas
								to: trainer_email,
							
								//cc-> opcional
								//cc: Hosts.contactFrom,
								subject: Hosts.webSiteTitle + ' - ' + language[lang].trainer_notify,
								//text: 'Teste de EMAIL ', -> opcional
								html: 
								'<html><head></head><body style="background-color:#F7F7F7;">' +
									'<div style="width:100% !important;margin-top:0;margin-bottom:0;margin-right:0;margin-left:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;color:#425968;background-color:#F7F7F7;background-image:none;background-repeat:repeat;background-position:top left;background-attachment:scroll;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:16px;">' +
									'<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0;margin-bottom:0;padding-top:0;padding-bottom:0;padding-right:0;padding-left:0;border-collapse:collapse;">' +
										'<tr style="border-collapse: collapse;">' +
										'<td style="border-collapse: collapse;">' +
											'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
											'<tr style="border-collapse: collapse;">' +
												'<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
												'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
													'<img style="width: 600px; height: 90px;" width="600" height="90" src="' + repo_banner_link("banner-email.jpg") + '"/>' +
												'</a>'+
												'</td>' +
											'</tr>' +
											'</table>' +
											'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:#ffffff;border:1px solid transparent;border-collapse:collapse;">' +
											'<tr style="border-collapse: collapse;">' +
												'<td align="left" class style="margin: 0 auto; padding: 15px 30px; border-collapse:collapse;">' +
												'<div>'+
													'<h4 style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;">'+ language[lang].trainer_notify +':</h4>'+
													'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">' + language[lang].hello + ', ' + trainer_name + '.</span>' +
													'<br/>'+
													'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].trainer_notify_email_text1 + '<b><label>' + module_name + '</label></b>'+ language[lang].trainer_notify_email_text2 + '<b>' + dados.current.content[0].title + '</b>' + language[lang].trainer_notify_email_text5 + '<b>'+ aux_data_inicio + '</b>.</span>'+
													'<br/>'+
													'<br/>'+
													'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].trainer_notify_email_text3 + '</span>'+
													'<br/>'+
													'<span style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].trainer_notify_email_text4 + '</span>'+
													'<br/>'+
													'<br/>'+
													'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_BACKOFFICE_URL + '" target="_blank" style="font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:18px;">'+ language[lang].access_app +'</a>'+
													'<br/>'+
												'</div>'+
												'</td>' +
											'</tr>' +
											'</table>' +
											'<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; background-color:' + Hosts.FOOTER_EMAIL_COLOR +'; padding: 10px; border:1px solid transparent;border-collapse:collapse;">' +
											'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding:10px 0px; border-collapse:collapse;">' +
												'<div style="margin: 0 auto; width:600px;">'+
													'<div style="text-align: center; font-size: small; color: #FFFFFF;">'+
													'<span style="text-transform: uppercase;font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteTitle + '</span>'+
													'<br/>'+
													'<span style="font-family:Arial,Helvetica,sans-serif;font-size:12px;">' + Hosts.webSiteAdress + '</span>'+
													'<br/>'+
													'<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_BACKOFFICE_URL + '" target="_blank" style="font-family:Arial,Helvetica,sans-serif;text-decoration:none;"> '+
														'<span style="color: #FFFFFF;font-family:Arial,Helvetica,sans-serif;font-size:12px;" >'+ Hosts.EMAIL_WEB_BACKOFFICE_URL +'</span>' +
													'</a>'+
													'</div>'+
												'</div>' +
												'</td>' +
											'</tr>' +
											'</table>' +
										'</td>' +
										'</tr>' +
									'</table>' +
									'</div>' +
								'<body><html>',
								//attachments -> opcional 
								// attachments: [     
								// 	{   // encoded string em Base 64
								// 	filename: 'text1.txt',
								// 	content: 'aGVsbG8gd29ybGQh',
								// 	encoding: 'base64'
								// 	},
								// ]
							
								};

							reqPOST(`${Hosts.SIMCore_API_MAIL}`, {data: mailOptions})
								.then(() => { 
									Swal.fire({
										title: language[lang].trainer_notify,
										html: language[lang].trainer_notify_success,
										icon: 'success'
									})
									setRefresh(refresh + 1)
								})
								.catch((error) => { 
									Swal.fire(language[lang].trainer_notify_error, '', 'info')
									console.log('ERROR SENDING EMAIL TO TRAINER: ', error)
								})

								

						})
						.catch((error) => { 
							Swal.fire(language[lang].trainer_notify_error, '', 'info')
							console.log('ERROR UPDATING FORMATION DATA: ', error)
						})
				}
			})

		}else {

			Swal.fire(language[lang].trainer_notify_error_button, '', 'warning')

		}
	};

	const removeSelectedTrainer = (index) => {

		set_dados(dados.current.content[0].modules[index].trainer = {
			email: '',
			id:  '',
			name: '',
			notified: false,
			username: ''
			
		})

		setRefresh(refresh + 1)

	};

	/* APPROVED TRAINEES */

	const removeInputTrainee = (index, trainee_id) => {

		//console.log(trainee_id)
		
		/* remove trainee from formation */
		let del_value = dados.current.content[0].trainees.slice(index, index + 1);
		//console.log('TESTE REMOVE', dados.current.content[0].trainees)
		let trainees = dados.current.content[0].trainees.filter(v => v.trainee_id !== del_value[0].trainee_id);

		dados.current.content[0].trainees = trainees

		if(dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0) { 

			dados.current.content[0].modules.forEach(v => {

				/* remove trainee from formation modules */
				let module_trainees = v.trainees.filter(v2 => v2.trainee_id !== trainee_id);

				v.trainees = module_trainees

				if(v.sessions !== undefined && v.sessions.length > 0) { 

					v.sessions.forEach(v3 => {

						/* remove trainee from module sessions */
						let sessions_trainees = v3.trainees.filter(v4 => v4.trainee_id !== trainee_id);

						v3.trainees = sessions_trainees

					});


				}

			});

		}

		setRefresh(refresh + 1)

		//set_dados(dados.current.content[0].trainees = trainees)

	};

	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { order, uid } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			let ext = v.name.substring(v.name.lastIndexOf(".") + 1);

			if ((aTypes.includes(ext)) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_name
				aux2[uid] = { name: v.name, size: v.size }
				set_files_doc_name(aux2)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				console.log(language[lang].upload_file_error + v.name);
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		});

		let files_aux = files_doc
		files_aux[uid] = { files: storedFiles, order: order, uid: uid }
		set_files_doc(files_aux)
	}

	const uploadFilesDoc = (files, order, uid, type) => {
		let aux = []
		files.forEach((element) => {
			//if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, uid, type)
					.then(() => {
						//console.log('success')
					})
			//}
			//else {
			//	Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			//}
		})
	}

	const uploadFile = async (file, order, uid, type) => {

		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', uid)
		formData.append('file_name', file.name)
		formData.append('type', 'user')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/users/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let x = {
					id: '',
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (type === 'doc') {

					dados.current.content[order]['trainees'].forEach((el_t) => {

						if(parseInt(el_t.trainee_id) === parseInt(uid)) {
							if(el_t['files'] === undefined) {
								el_t['files'] = []
							}
		
							el_t['files'][0] = {
								id: '',
								link: res.data.path + '/' + res.data.name,
								name: file.name,
								description: '',
								type: type,
								order: order
							}
						}

					})

				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const removeCertificateFile = (order, trainee_id) => {

		// console.log('order', order)
		// console.log('trainee_id', trainee_id)
		// console.log(dados.current.content[order]['trainees'])
		dados.current.content[order]['trainees'].forEach((el_t) => {

			if(parseInt(el_t.trainee_id) === parseInt(trainee_id)) {
				if(el_t['files'] === undefined) {
					el_t['files'] = []
				}

				el_t['files'] = []

				set_dados(dados.current.content[order]['trainees'], )
			}

		})
	}


	return isloading ?
		
		<Loader />
		
		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].gest}</h2>
					<span>
						<Link to={{ pathname: endpoints.list }}  >
							{language[lang].content}
						</Link>
						&nbsp;&#47;&nbsp;
						{language[lang].content_gest}
					</span>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row mb-5">
							{/*console.log('FORMAÇÃO ---------->', dados.current)*/}

							<div className='col-12 border-bottom'>
								<h3 className="fw-bolder">{language[lang].content}</h3>
							</div>
							<div className='col-12 mt-3'>
								<span className='fw-bold'>{dados.current.content[0].title}</span>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].date_begin}&#58;&nbsp;
								</label>
								<span>
									{dados.current.info.date.begin.split('T')[0]}
								</span>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].financing}&#58;&nbsp;
								</label>
								<span>
									{language[lang][dados.current.content[0].financing]}
								</span>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].module_evaluations}&#58;&nbsp;
								</label>
								<button
									className="action ms-3"
									type="button" 
									alt={language[lang].final_evaluation}
									title={language[lang].final_evaluation}
									data-bs-toggle="modal"
									data-bs-target={"#formationTraineesFinalEvaluationModal"}
									>
										<i className="bi bi-table fs-3"></i>
										<span className="tooltiptext d-none" style={{left: 'unset', right: 10}}>{language[lang].final_evaluation}</span>
								</button>
								<div className={"modal bg-light fade"} id={"formationTraineesFinalEvaluationModal"} tabIndex="-1" aria-labelledby={"formationTraineesFinalEvaluationModalLabel"} aria-hidden="true" >
									<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title" id={"formationTraineesFinalEvaluationModalLabel"}>
													{dados.current.content[0].title}
												</h5>
												<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
											</div>
											<div className="modal-body">
												<div className="col-12">
													<label className="col-form-label fw-bold">
														{language[lang].module_evaluations}
													</label>
												</div>
												<div className="col-12 mb-4">
													<label className="col-form-label fw-bold d-block">
														{language[lang].attendance_record_label}
													</label>
													<span className='d-flex align-items-center'>
														<i className={"bi bi-clipboard-x fs-3"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>
														&nbsp;
														{language[lang].module_evaluations_soon}
													</span>
												</div>
												<div className="col-12 table-responsive">
													<table className="table table-striped table-hover table-bordered align-middle">
														<thead>
															<tr>
																<th className="fs-6 fw-bold">{language[lang].trainee}</th>
																<th className="fs-6 fw-bold">{language[lang].final_evaluation}</th>
															</tr>
														</thead>
																		
														<tbody >
															{ 
																dados.current.content[0].trainees !== undefined && dados.current.content[0].trainees.length > 0 ? (
																	dados.current.content[0].trainees.map( ( v , index4 ) => {
																			
																		if(v.trainee_id === '')
																			return ''
																		else
																			return(

																				<tr key = {`${index4}`}>
																					<td>
																						<label className="col-form-label">{v.trainee_name}</label>
																					</td>
																					<td>
																						{
																							v.trainee_final_evaluation !== undefined && v.trainee_final_evaluation !== '' ?
																								v.trainee_final_evaluation
																							:
																								<i className={"bi bi-clipboard-x fs-4"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>

																						}
																					</td>

																				</tr>

																			)
																	})
																) : <tr>
																		<td>
																			<span className='fw-bold'>{language[lang].trainees_empty}</span>
																		</td>
																	</tr>
															}
														</tbody>
													</table>
												</div>
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-secondary d-print-none" data-bs-dismiss="modal">{language[lang].close}</button>
											</div>
										</div>
									</div>
								</div>
								<button
									className="action ms-3"
									type="button" 
									alt={language[lang].module_evaluation_detailed}
									title={language[lang].module_evaluation_detailed}
									data-bs-toggle="modal"
									data-bs-target={"#formationTraineesCompleteEvaluationModal"}
									>
										<i className="bi bi-table fs-3"></i>
										<span className="tooltiptext d-none" style={{left: 'unset', right: 10}}>{language[lang].module_evaluation_detailed}</span>
								</button>
								<div className={"modal bg-light fade"} id={"formationTraineesCompleteEvaluationModal"} tabIndex="-1" aria-labelledby={"formationTraineesCompleteEvaluationModalLabel"} aria-hidden="true" >
									<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title" id={"formationTraineesCompleteEvaluationModalLabel"}>
													{dados.current.content[0].title}
												</h5>
												<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
											</div>
											<div className="modal-body">
												<div className="col-12">
													<label className="col-form-label fw-bold">
														{language[lang].module_evaluations}
													</label>
												</div>
												<div className="col-12 mb-4">
													<label className="col-form-label fw-bold d-block">
														{language[lang].attendance_record_label}
													</label>
													<span className='d-flex align-items-center'>
														<i className={"bi bi-clipboard-x fs-3"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>
														&nbsp;
														{language[lang].module_evaluations_soon}
													</span>
												</div>
												<div className="col-12 table-responsive">
													<table className="table table-striped table-hover table-bordered align-middle">
														<thead>
															<tr>
																<th className="fs-6 fw-bold">{language[lang].trainee}</th>
																<th className="fs-6 fw-bold">{language[lang].final_evaluation}</th>
																{ 
																	dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0 ? (
																			
																		dados.current.content[0].modules.map( ( elem2 , index2 ) => {

																			//console.log('sessões: ', elem2)
																			
																			if(elem2.name === '')
																				return ''
																			else
																				return(
																					
																					<th key = {`${index2}`} className="fs-6 fw-bold">
																						{elem2.name}
																					</th>
																					
																				)
																		})											
																			
																	) : <th className='fw-bold'>{language[lang].sessions_empty}</th>
																}
															</tr>
														</thead>
																		
														<tbody >
															{ 
																dados.current.content[0].trainees !== undefined && dados.current.content[0].trainees.length > 0 ? (
																	dados.current.content[0].trainees.map( ( v , index4 ) => {
																			
																		if(v.trainee_id === '')
																			return ''
																		else
																			return(

																				<tr key = {`${index4}`}>
																					<td>
																						<label className="col-form-label">{v.trainee_name}</label>
																					</td>
																					<td>
																						{
																							v.trainee_final_evaluation !== undefined && v.trainee_final_evaluation !== '' ?
																								v.trainee_final_evaluation
																							:
																								<i className={"bi bi-clipboard-x fs-4"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>

																						}
																					</td>
																					{

																						dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0 ? (
																							dados.current.content[0].modules.map( ( elem4 , index5 ) => {

																								//console.log('sessão', elem4)
																								//let today = new Date().toJSON()

																								return (
																									<td key = {`${index5}`}>

																										{ 
																											elem4.trainees !== undefined && elem4.trainees.length > 0 ? (
																												elem4.trainees.map( ( v2 , index6 ) => {

																													if(v2.trainee_id === v.trainee_id)
																														return (
																															<div key = {`${index6}`}>
																															
																																{
																																	v2.trainee_module_evaluation !== undefined && v2.trainee_module_evaluation !== '' ?
																																		v2.trainee_module_evaluation
																																	:
																																		<i className={"bi bi-clipboard-x fs-4"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>

																																}

																															</div>

																															
																														)
																													else return null
																												})
																											) : <span className='fw-bold'>{language[lang].trainees_empty}</span>
																										}
																									</td>

																								)
																							})
																						) : <th className='fw-bold'>{language[lang].sessions_empty}</th>
																					}

																				</tr>

																			)
																	})
																) : <tr>
																		<td>
																			<span className='fw-bold'>{language[lang].trainees_empty}</span>
																		</td>
																	</tr>
															}
														</tbody>
													</table>
												</div>
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-secondary d-print-none" data-bs-dismiss="modal">{language[lang].close}</button>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="col-12 mt-3">
								<label className='fw-bold d-block'>
									{language[lang].shortcuts}&#58;&nbsp;
								</label>
								<LinkScroll activeClass="active" to="modules" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary" alt={language[lang].modules} title={language[lang].modules}>
									<img className="assec-mr-15 d-none" alt={language[lang].modules} title={language[lang].modules} src={'./img/plus.svg'} />
									<i className="bi bi-eye text-white me-2"></i>
									{language[lang].modules}
								</LinkScroll>
								<LinkScroll activeClass="active" to="applicants" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary ms-2" alt={language[lang].formation_registrations} title={language[lang].formation_registrations}>
									<img className="assec-mr-15 d-none" alt={language[lang].formation_registrations} title={language[lang].formation_registrations} src={'./img/plus.svg'} />
									<i className="bi bi-eye text-white me-2"></i>
									{language[lang].formation_registrations}
								</LinkScroll>
								<LinkScroll activeClass="active" to="trainees" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary ms-2" alt={language[lang].trainees} title={language[lang].trainees}>
									<img className="assec-mr-15 d-none" alt={language[lang].trainees} title={language[lang].trainees} src={'./img/plus.svg'} />
									<i className="bi bi-eye text-white me-2"></i>
									{language[lang].trainees}
								</LinkScroll>
							</div>

						</div>
						{
							//formation trainers
							is_edit === true /*&& add_trainers_permission*/ ?

								<div className="row mb-3" id="trainers">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].trainer}</h3>
									</div>
									<div className="col-12 col-md-8 my-3">
										<div className="row">
											<div className="col-12 col-sm-6">
												<Select
													options={trainers}
													name="trainer"
													placeholder={language[lang].select_trainer_placeholder}
													value={trainer_selected.label === '' ? null : trainer_selected}
													onChange={handle_selected_trainers}
													menuPlacement='top'
													//styles={custom_select_styles}
												/>
												
												
											</div>
											<div className="col-12 col-sm-6">
												<button className="btn btn-primary" type="button" onClick={add_trainer} alt={language[lang].add_trainer} title={language[lang].add_trainer}>
													<img className="assec-mr-15" alt={language[lang].add_trainer} title={language[lang].add_trainer} src={'./img/plus.svg'} />
													{language[lang].add_trainer}
												</button>
											</div>
											{ 
												dados.current.info.trainers !== undefined && dados.current.info.trainers.length > 0 ? (
													<div className="col-12 col-sm-6">
														<label className='col-form-label fw-bold fs-6'>{language[lang].trainers}</label>
														{
															dados.current.info.trainers.map( ( elem , index ) => {
																
																if(elem.name === '')
																	return ''
																else
																	return(
																		
																		<div  key = { `${index}` } className="d-flex mb-3">

																			<div className='input-group'>
																				<div className='input-group-text p-0'>
																					<Link
																						title={language[lang].profile_view}
																						alt={language[lang].profile_view}
																						to={{ 
																							pathname: '/trainer_view',
																							state: {
																								item: {id: elem.id},
																								operation: 'view',
																								backup_operation: 'profile_view',
																								formation_id: dados.current.id
																							},
																						}} >
																						<i className="bi bi-person-fill fs-4 px-2 text-primary"></i>
																					</Link>
																				</div>
																				<input
																					type="text" 
																					className = "form-control"  
																					name ="nome"  
																					value = { elem.name } 
																					data-index = { index }
																					readOnly
																				/>
																				
																				<button  type="button" className = "ms-3 assec-btn-remove" onClick = {() => removeInputTrainer(index) }>
																					<img src ="./img/adicionar.svg" alt={language[lang].remove_trainer} title={language[lang].remove_trainer} />
																				</button>
																				{/* <button className={(elem.trainers.notified === true ? 'button-green' : 'button-yellow') + " ml-4"} type="button" onClick={ () => save_reviewer_and_send_notification(elem.trainers.id, elem.trainers.name)}>
																					{(elem.trainers.notified === true ? language[lang].notified : language[lang].notify)}
																				</button> */}
																			</div>
																		</div>
																		
																	)
															})											
														}
														
													</div>
												) : null 
											}
										</div>

									</div>
								</div>
							: ''
						}

						{
							//formation modules
							is_edit === true /*&& add_trainers_permission*/ ?

								<div className="row mb-3" id="modules">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].modules}</h3>
									</div>
									<div className="col-12 my-3">
										<div className="row">
											<div className='col-12 mt-3 d-none'>
												<h4 className="fw-bolder">{language[lang].candidates}</h4>
											</div>

											{ 
												dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0 ? (
														
													dados.current.content[0].modules.map( ( elem , index ) => {

														//console.log('Módulos: ', elem)
														if(elem.trainer !== undefined && elem.trainer.id !== undefined && dados.current.info.trainers !== undefined) {
															var aux_module_trainer = JSON.stringify(dados.current.info.trainers.find(v => (v.id === elem.trainer.id)))
															//console.log('aux trainer: ', JSON.stringify(aux_trainer))
														}else{
															elem.trainer = { 
																email: '',
																id:  '',
																name: '',
																notified: false,
																username: ''
																
															}
														}
														
														if(elem.name === '')
															return ''
														else
															return(
																
																<div  key = { `${index}` } className="col-12 mb-3">
																	<div className='row'>
																		<div className='col-12 col-md-2'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold invisible'>{language[lang].profile}</label>
																				:
																					null
																			}
																			<div className='d-flex align-items-center position-relative'>
																				<Link 
																					className="btn btn-link"
																					to={{ 
																						pathname: '/formation_module_regist',
																						state: {
																							item: {id_formation: dados.current.id, id_module: elem.id},
																							operation: 'edit',
																							backup_operation: 'module_view',
																							formation_id: dados.current.id
																						},
																					}} >
																					<span>{language[lang].module_view}</span>
																				</Link>
																				<button
																					className="action ms-3"
																					type="button" 
																					alt={language[lang].attendance_record}
																					title={language[lang].attendance_record}
																					data-bs-toggle="modal"
																					data-bs-target={"#moduleAttendanceListModal_" + index}
																					>
																						<i className="bi bi-people fs-3"></i>
																						<span className="tooltiptext">{language[lang].attendance_record}</span>
																				</button>
																				<div className={"modal bg-light fade"} id={"moduleAttendanceListModal_" + index} tabIndex="-1" aria-labelledby={"moduleAttendanceListModalLabel_" + index} aria-hidden="true" >
																					<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
																						<div className="modal-content">
																							<div className="modal-header">
																								<h5 className="modal-title" id={"moduleAttendanceListModalLabel_" + index}>
																									{elem.name}
																								</h5>
																								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																							</div>
																							<div className="modal-body">
																								<div className="col-12">
																									<label className="col-form-label fw-bold">
																										{language[lang].attendance_record}
																									</label>
																								</div>
																								<div className="col-12 mb-4">
																									<label className="col-form-label fw-bold d-block">
																										{language[lang].attendance_record_label}
																									</label>
																									<span className='d-inline-flex align-items-center'>
																										<i className={"bi bi-check fs-3 text-success"} alt={language[lang].attendance_record_present} title={language[lang].attendance_record_present}></i>
																										&nbsp;
																										{language[lang].attendance_record_present}
																									</span>
																									<span className='d-inline-flex align-items-center'>
																										<i className={"bi bi-x fs-3 text-danger"} alt={language[lang].attendance_record_missed} title={language[lang].attendance_record_missed}></i>
																										&nbsp;
																										{language[lang].attendance_record_missed}
																									</span>
																									<span className='d-flex align-items-center'>
																										<i className={"bi bi-calendar-x fs-3"} alt={language[lang].attendance_record_soon} title={language[lang].attendance_record_soon}></i>
																										&nbsp;
																										{language[lang].attendance_record_soon}
																									</span>
																								</div>
																								<div className="col-12 table-responsive">
																									<table className="table table-striped table-hover table-bordered align-middle">
																										<thead>
																											<tr>
																												<th className="fs-6 fw-bold">{language[lang].trainee}</th>
																												{ 
																													elem.sessions !== undefined && elem.sessions.length > 0 ? (
																															
																														elem.sessions.map( ( elem2 , index2 ) => {

																															//console.log('sessões: ', elem2)
																															
																															if(elem2.name === '')
																																return ''
																															else
																																return(
																																	
																																	<th key = {`${index2}`} className="fs-6 fw-bold">
																																		{elem2.name}
																																	</th>
																																	
																																)
																														})											
																															
																													) : <th className='fw-bold'>{language[lang].sessions_empty}</th>
																												}
																											</tr>
																										</thead>
																										{ 
																											elem.sessions !== undefined && elem.sessions.length > 0 ? (
																													
																												elem.sessions.map( ( elem3 , index3 ) => {

																													if(index3 === 0) 

																													return(
																														
																														<tbody key = {`${index3}`}>
																															{ 
																																elem3.trainees !== undefined && elem3.trainees.length > 0 ? (
																																	elem3.trainees.map( ( v , index4 ) => {
																																			
																																		if(v.trainee_id === '')
																																			return ''
																																		else
																																			return(

																																				<tr key = {`${index4}`}>
																																					<td>
																																						<label className="col-form-label fs-6">{v.trainee_name}</label>
																																					</td>

																																					{
																																						elem.sessions.map( ( elem4 , index5 ) => {

																																							//console.log('sessão', elem4)
																																							let today = new Date().toJSON()

																																							return (
																																								<td key = {`${index5}`}>

																																									{ 
																																										elem4.trainees !== undefined && elem4.trainees.length > 0 ? (
																																											elem4.trainees.map( ( v2 , index6 ) => {

																																												let aux_trainee_session_attendance = ''
																																												let trainee_session_attendance_icon = ''

																																												if(v2.trainee_session_attendance !== undefined && v2.trainee_session_attendance !== '' && v2.trainee_session_attendance === true){
																																													aux_trainee_session_attendance = language[lang].attendance_record_present
																																													trainee_session_attendance_icon = 'check fs-3 text-success'

																																												}else if (v2.trainee_session_attendance !== undefined && v2.trainee_session_attendance !== '' && v2.trainee_session_attendance === false && (today > elem4.data)){
																																													aux_trainee_session_attendance = language[lang].attendance_record_missed
																																													trainee_session_attendance_icon = 'x fs-3 text-danger'
																																												}
																																												else {
																																													aux_trainee_session_attendance = language[lang].attendance_record_soon
																																													trainee_session_attendance_icon = 'calendar-x fs-3'
																																												}

																																												if(v2.trainee_id === v.trainee_id)
																																													return (
																																														<i key = {`${index6}`} className={"bi bi-" + trainee_session_attendance_icon} alt={aux_trainee_session_attendance} title={aux_trainee_session_attendance}></i>
																																													)
																																												else return null
																																											})
																																										) : <span className='fw-bold'>{language[lang].trainees_empty}</span>
																																									}
																																								</td>

																																							)
																																						})
																																					}

																																				</tr>

																																			)
																																	})
																																) : <tr>
																																		<td>
																																			<span className='fw-bold'>{language[lang].trainees_empty}</span>
																																		</td>
																																	</tr>
																															}
																														</tbody>
																														
																													)
																													else return null
																													
																												})											
																													
																											) : null /*<span className='fw-bold'>{language[lang].sessions_empty}</span>*/
																										}
																									</table>
																								</div>
																							</div>
																							<div className="modal-footer">
																								<button type="button" className="btn btn-secondary d-print-none" data-bs-dismiss="modal">{language[lang].close}</button>
																							</div>
																						</div>
																					</div>
																				</div>
																				<button
																					className="action ms-3"
																					type="button" 
																					alt={language[lang].module_evaluations}
																					title={language[lang].module_evaluations}
																					data-bs-toggle="modal"
																					data-bs-target={"#moduleTraineesEvaluationModal_" + index}
																					>
																						<i className="bi bi-table fs-3"></i>
																						<span className="tooltiptext" style={{left: 'unset', right: 10}}>{language[lang].module_evaluations}</span>
																				</button>
																				<div className={"modal bg-light fade"} id={"moduleTraineesEvaluationModal_" + index} tabIndex="-1" aria-labelledby={"moduleTraineesEvaluationModalLabel_" + index} aria-hidden="true" >
																					<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
																						<div className="modal-content">
																							<div className="modal-header">
																								<h5 className="modal-title" id={"moduleTraineesEvaluationModalLabel_" + index}>
																									{elem.name}
																								</h5>
																								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																							</div>
																							<div className="modal-body">
																								<div className="col-12">
																									<label className="col-form-label fw-bold">
																										{language[lang].module_evaluations}
																									</label>
																								</div>
																								<div className="col-12 mb-4">
																									<label className="col-form-label fw-bold d-block">
																										{language[lang].attendance_record_label}
																									</label>
																									<span className='d-inline-flex align-items-center d-none'>
																										<i className={"bi bi-check fs-3 text-success"} alt={language[lang].attendance_record_present} title={language[lang].attendance_record_present}></i>
																										&nbsp;
																										{language[lang].attendance_record_present}
																									</span>
																									<span className='d-inline-flex align-items-center d-none'>
																										<i className={"bi bi-x fs-3 text-danger"} alt={language[lang].attendance_record_missed} title={language[lang].attendance_record_missed}></i>
																										&nbsp;
																										{language[lang].attendance_record_missed}
																									</span>
																									<span className='d-flex align-items-center'>
																										<i className={"bi bi-clipboard-x fs-3"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>
																										&nbsp;
																										{language[lang].module_evaluations_soon}
																									</span>
																								</div>
																								<div className="col-12 table-responsive">
																									<table className="table table-striped table-hover table-bordered align-middle">
																										<thead>
																											<tr>
																												<th className="fs-6 fw-bold">{language[lang].trainee}</th>
																												<th className="fs-6 fw-bold">{language[lang].module_evaluation}</th>
																											</tr>
																										</thead>
																														
																										<tbody >
																											{ 
																												elem.trainees !== undefined && elem.trainees.length > 0 ? (
																													elem.trainees.map( ( v , index4 ) => {
																															
																														if(v.trainee_id === '')
																															return ''
																														else
																															return(

																																<tr key = {`${index4}`}>
																																	<td>
																																		<label className="col-form-label">{v.trainee_name}</label>
																																	</td>
																																	<td>
																																		{
																																			v.trainee_module_evaluation !== undefined && v.trainee_module_evaluation !== '' ?
																																				v.trainee_module_evaluation
																																			:
																																				<i className={"bi bi-clipboard-x fs-4"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>

																																		}
																																	</td>

																																</tr>

																															)
																													})
																												) : <tr>
																														<td>
																															<span className='fw-bold'>{language[lang].trainees_empty}</span>
																														</td>
																													</tr>
																											}
																										</tbody>
																									</table>
																								</div>
																							</div>
																							<div className="modal-footer">
																								<button type="button" className="btn btn-secondary d-print-none" data-bs-dismiss="modal">{language[lang].close}</button>
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div className='col-12 col-md-4'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].name}</label>
																				:
																				 	null
																			}
																			<input
																				type="text" 
																				className = "form-control"  
																				name ="name"  
																				value = { elem.name }
																				readOnly
																			/>
																		</div>
																		
																		<div className='col-12 col-md-1 d-none'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold invisible'>{language[lang].profile}</label>
																				:
																				 	null
																			}
																			{ 
																				elem.trainer !== undefined && elem.trainer.id !== undefined &&  elem.trainer.id !== '' ? (
																					<div>
																						<Link 
																							className="btn btn-link"
																							to={{ 
																								pathname: '/trainer_view',
																								state: {
																									item: {id: elem.trainer.id},
																									operation: 'view',
																									backup_operation: 'profile_view',
																									formation_id: dados.current.id
																								},
																							}} >
																							<span>{language[lang].profile_view}</span>
																						</Link>
																					</div>
																				) : null 
																			}
																		</div>
																			
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>
																						{language[lang].trainer_assign}
																					</label>
																				:
																				 	null
																			}
																			<div className='input-group'>
																				{ 
																					elem.trainer !== undefined && elem.trainer.id !== undefined &&  elem.trainer.id !== '' ? (
																						<div className='input-group-text d-flex justify-content-center align-items-center me-3 d-none'>
																							<Link
																								title={language[lang].profile_view}
																								alt={language[lang].profile_view}
																								to={{ 
																									pathname: '/trainer_view',
																									state: {
																										item: {id: elem.trainer.id},
																										operation: 'view',
																										backup_operation: 'profile_view',
																										formation_id: dados.current.id
																									},
																								}} >
																								<i className="bi bi-info-circle fs-6 text-primary"></i>
																							</Link>
																						</div>
																					) : null 
																				}
																				<select className="form-select rounded-0" aria-label="Select Trainer" name='trainer' data-index = { index } value={elem.trainer !== undefined && elem.trainer.id !== undefined && elem.trainer.id !== '' ? aux_module_trainer : '---'}/*value={elem.trainer !== undefined ? JSON.stringify(elem.trainer) : ''}*/ onChange={handle_change_module_trainer}>
																					<option value="---">---</option>
																					{ 
																						dados.current.info.trainers !== undefined && dados.current.info.trainers.length > 0 ? (
																								
																							dados.current.info.trainers.map( ( v , index2 ) => {
																								//console.log('FORMATION TRAINERS: ', v)
																								return (
																									<option key = { `${index2}` } value={JSON.stringify(v)} >{v.name}</option>
																									)
																							})
																						) : null 
																					}
																				</select>
																				<button type="button" className = "ms-3 assec-btn-remove" onClick = {() => removeSelectedTrainer(index) }>
																					<img src ="./img/adicionar.svg" alt={language[lang].trainer_remove} title={language[lang].trainer_remove} />
																				</button>
																			</div>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold d-block invisible'>{language[lang].table_actions}</label>
																				:
																					null
																			}
																			<button type="button" onClick={() => notifyTrainerAndSave(elem.trainer.id, elem.trainer.name, elem.trainer.email, elem.name, index)} className={elem.trainer.notified !== undefined && elem.trainer.notified === true ? "btn btn-success" : "btn btn-primary"} >
																				<span>{elem.trainer.notified !== undefined && elem.trainer.notified === true ? language[lang].trainer_notified : language[lang].trainer_notify_button}</span>
																			</button>
																			<button type="button" className = "ms-3 assec-btn-remove d-none" onClick = {() => removeSelectedTrainer(index) }>
																				<img src ="./img/adicionar.svg" alt={language[lang].trainer_remove} title={language[lang].trainer_remove} />
																			</button>
																		</div>
																	</div>
																	
																</div>
																
															)
													})											
														
												) : <span className='fw-bold'>{language[lang].modules_empty}</span>
											}
										</div>

									</div>
								</div>
							: ''
						}

						{
							//formation applicants/trainees
								('Administrador' === getTokenInfo().profile) ?

								<div className="row mb-3" id="applicants">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].formation_registrations}</h3>
									</div>

									{/* COM TABS*/}
									<div className='col-12 mt-3 align-items-center'>
										<div className='nav nav-pills' role="tablist">
											<button className="nav-link active" id="candidates-tab" data-bs-toggle="pill" data-bs-target="#candidates" type="button" role="tab" aria-controls="candidates" aria-selected="true">
												Avaliar inscrições
											</button>
											<button className="nav-link" id="users-tab" data-bs-toggle="pill" data-bs-target="#users" type="button" role="tab" aria-controls="users" aria-selected="true">
												Adicionar formandos registados
											</button>
										</div>
									</div>
									<div className="tab-content" id="registrations-tabContent">
										<div className="tab-pane fade show active" id="candidates" role="tabpanel" aria-labelledby="candidates-tab">
											<div className="col-12 my-3">
												<div className="row">
													<div className='col-12 mt-3'>
														<h4 className="fw-bolder">{language[lang].candidates}</h4>
													</div>
													{ 
														dados.current.content[0].candidates !== undefined && dados.current.content[0].candidates.length > 0 ? (
																
															dados.current.content[0].candidates.map( ( elem , index ) => {

																if(elem.trainee_rejection_reason === undefined)
																	elem.trainee_rejection_reason = ''
																
																if(elem.trainee_name === '')
																	return ''
																else
																	return(
																		
																		<div  key = { `${index}` } className="col-12 mb-3">
																			<div className='row'>
																				<div className='col-12 col-md-1 d-none'>
																					{
																						index === 0 ?
																							<label className='col-form-label fw-bold invisible'>{language[lang].profile}</label>
																						:
																							null
																					}
																					<div>
																						<Link 
																							className="btn btn-link"
																							to={{ 
																								pathname: '/trainee_view',
																								state: {
																									item: {id: elem.trainee_id},
																									operation: 'view',
																									backup_operation: 'profile_view',
																									formation_id: dados.current.id
																								},
																							}} >
																							<span>{language[lang].profile_view}</span>
																						</Link>
																					</div>
																				</div>
																				<div className='col-12 col-md-3'>
																					{
																						index === 0 ?
																							<label className='col-form-label fw-bold'>{language[lang].name}</label>
																						:
																							null
																					}
																					<div className='input-group'>
																						<div className='input-group-text p-0'>
																							<Link
																								title={language[lang].profile_view}
																								alt={language[lang].profile_view}
																								to={{ 
																									pathname: '/trainee_view',
																									state: {
																										item: {id: elem.trainee_id},
																										operation: 'view',
																										backup_operation: 'profile_view',
																										formation_id: dados.current.id
																									},
																								}} >
																								<i className="bi bi-person-fill fs-4 px-2 text-primary"></i>
																							</Link>
																						</div>
																						<input
																							type="text" 
																							className = "form-control rounded-0"  
																							name ="trainee_name"  
																							value = { elem.trainee_name }
																							readOnly
																						/>
																					</div>
																				</div>
																				<div className='col-12 col-md-3'>
																					{
																						index === 0 ?
																							<label className='col-form-label fw-bold'>
																								{language[lang].table_state}
																							</label>
																						:
																							null
																					}
																					<div className='input-group'>
																						{
																							elem.candidate_data !== undefined && elem.candidate_data.length > 0 ? (
																								<div className='input-group-text p-0'>
																									<button
																										className='action'
																										type="button" 
																										alt={language[lang].state_change_view}
																										title={language[lang].state_change_view}
																										data-bs-toggle="offcanvas" 
																										data-bs-target={"#offcanvasStatusInfoCandidate_"+ index}
																										aria-controls={"offcanvasStatusInfoCandidate_"+ index}
																										>
																											<i className="bi bi-person-gear fs-4 px-2"></i>
																											<span className="tooltiptext d-none">{language[lang].state_change_view}</span>
																									</button>
																								</div>
																							) : null 
																						}
																						<div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="true" tabIndex="-1" id={"offcanvasStatusInfoCandidate_"+ index} aria-labelledby={"offcanvasStatusInfoCandidate_" + index + "_Label"}>
																							<div className="offcanvas-header">
																								<h5 className="offcanvas-title" id={"offcanvasStatusInfoCandidate_" + index + "_Label"}>{elem.trainee_name}</h5>
																								<button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
																							</div>
																							<div className="offcanvas-body">

																								<div className='col-12 status-info'>
																									<h6 className='fw-bold'>{language[lang].state_change}</h6>

																									{ 
																										elem.candidate_data !== undefined && elem.candidate_data.length > 0 ? (

																											<div className="accordion border-0 mb-5" id="accordionDateStatus"> 

																												{
																													elem.candidate_data.map( ( elem2 , k ) => {

																														return(
																																<div key={k}>
																			
																																	<div className="accordion-item mt-3">

																																		<div className="accordion-header" id={'trainee-'+ index + '-heading-' + k}>
																																			<button className={"accordion-button collapsed"} type="button" data-bs-toggle="collapse" data-bs-target={'#trainee-'+ index + '-collapse-' + k} aria-expanded="true" aria-controls={'trainee-'+ index + '-collapse-' + k}>
																																				{
																																					elem2['date'] !== undefined && elem2.date !== '' ?
																																						<span>{elem2.date.split('T')[0]}</span>
																																					:
																																						<span>{language[lang].state_change_date_empty}</span>
																																				}
																																				{
																																					elem2.status !== undefined && elem2.status !== '' ?
																																						<span className={elem2.status === 'accepted' ? 'text-success': (elem2.status === 'rejected' ? 'text-danger' : 'text-warning')}>
																																							&nbsp;&#45;&nbsp;{language[lang][elem2.status]}
																																						</span>
																																					:
																																						null
																																				}
																																			</button>
																																		</div>
																																		<div id={'trainee-'+ index + '-collapse-' + k} className={"accordion-collapse collapse"} aria-labelledby={'trainee-'+ index + '-heading-' + k} data-bs-parent="#accordionDateStatus">
																																			<div className="accordion-body">

																																				{
																																					elem2.qualifications !== undefined && elem2.qualifications.name !== '' ?
																																						<div className='col-12 mb-3'>
																																							<label className='col-form-label fw-bold d-block'>
																																								{language[lang].state_change_educational_background}
																																								&#58;
																																							</label>
																																							<span>
																																								{elem2.qualifications.name}
																																							</span>
																																						</div>
																																					:
																																						null
																																				}

																																				{
																																					elem2.employment !== undefined && elem2.employment.employment_status !== '' ?
																																						<div className='col-12 mb-3'>
																																							<label className='col-form-label fw-bold d-block'>
																																								{language[lang].state_change_employment_status}
																																								&#58;
																																							</label>
																																							<span>
																																								{elem2.employment.employment_status}
																																							</span>
																																						</div>
																																					:
																																						null
																																				}

																																				{
																																					elem2.employment !== undefined && elem2.employment.employment_status === 'Empregado por conta de outrem' ?
																																					<div className="col-12">
																																						<div className="row">
																																							<div className='col-12 mb-3'>
																																								<label className='col-form-label fw-bold d-block'>
																																									{language[lang].state_change_employer_entity}
																																									&#58;
																																								</label>
																																								<span>
																																									{elem2.employment.employer_entity}
																																								</span>
																																							</div>
																																							<div className='col-12 mb-3'>
																																								<label className='col-form-label fw-bold d-block'>
																																									{language[lang].state_change_business_sector}
																																									&#58;
																																								</label>
																																								<span>
																																									{elem2.employment.business_sector}
																																								</span>
																																							</div>
																																							<div className='col-12 mb-3'>
																																								<label className='col-form-label fw-bold d-block'>
																																									{language[lang].state_change_employment_role}
																																									&#58;
																																								</label>
																																								<span>
																																									{elem2.employment.employment_role}
																																								</span>
																																							</div>
																																						</div>
																																					</div>
																																					:
																																						null
																																				}

																																				{ 

																																					elem2.files !== undefined && elem2.files.length > 0 ? (

																																						<div className='row'>
																																							<label className='col-form-label fw-bold d-block'>
																																								{language[lang].state_change_documents}
																																							</label>

																																							{

																																								elem2.files.map( ( v , f_index ) => {

																																									let aux_type = v.type

																																									if(aux_type === 'emprego-horario') {

																																										aux_type = 'emprego_horario'

																																									}

																																									if(v.link === '')
																																										return ''

																																									return (
																																											
																																										<div key = { `${f_index}` } className='col-12 mb-2'>
																																											<label className='col-form-label fw-bold d-block'>
																																												{language[lang]['state_change_doc_' + aux_type]}
																																											</label>
																																											<i className="bi bi-bookmark me-2"></i>
																																											<a href={v.link} alt={language[lang].file_view} title={language[lang].file_view} target='_blank' rel="noreferrer">
																																												{v.name}
																																											</a>
																																										</div>
																																									)

																																								})
																																							}
																																						</div>

																																					) : null
																																				}

																																			</div>
																																		</div>
																																	</div>
																																
																																</div>
																															
																														)

																													})
																												}
																											</div>


																										) : <span className='fw-bold'>{language[lang].state_change_empty}</span>
																									}
																									
																								</div>
																								<div className='col-12 mt-5'>
																									<button type="submit" form="form" className="btn btn-primary d-none">
																										<span>{language[lang].save}</span>
																									</button>
																									<button type="button" className="btn btn-secondary ms-2" data-bs-dismiss="offcanvas">{language[lang].close}</button>
																								</div>
																							</div>
																						</div>

																						{/*<Select
																							//className={"div-select " + (estado_selected.value === 'accepted' ? 'green' : '') + (estado_selected.value === 'accepted_change' ? 'yellow' : '') + (estado_selected.value === 'rejected' ? 'red' : '') + ((estado_selected.value === undefined || estado_selected.value === '' || estado_selected.value === 'under_review') ? 'gray' : '')}
																							options={ select_option_util_fun_2( [ {l: language[lang].accepted, v: 'accepted'} , {l: language[lang].accepted_change, v: 'accepted_change'}, {l: language[lang].rejected, v: 'rejected'} ] ) }
																							name="trainee_status"
																							value={(dados.current.info.reviewer_access[0] === undefined) ? null : { label: dados.current.info.reviewer_access[0].status, value: dados.current.info.reviewer_access[0].status }}
																							//value={estado_selected.value === '' ? null : { label: language[lang][estado_selected.value], value: estado_selected.value }}
																							//placeholder={language[lang].select_state_placholder}
																							onChange={handle_selected_estado}
																							styles={custom_select_styles_status}
																						/>*/}

																						<select className="form-select rounded-0" aria-label="Select Status" name='trainee_status' data-index = { index } data-trainee_id={elem.trainee_id} data-trainee_name={elem.trainee_name} data-trainee_email={elem.trainee_email} value={elem.trainee_status} onChange={handle_change_candidates}>
																							<option value="under_review">{language[lang].under_review}</option>
																							<option value="accepted">{language[lang].accepted}</option>
																							{/*<option value="accepted_change">{language[lang].accepted_change}</option>*/}
																							<option value="rejected">{language[lang].rejected}</option>
																						</select>
																						{ 
																							elem.trainee_status === 'rejected' ? (
																								<div className='input-group-text p-0'>
																									<button type="button" alt={language[lang].rejected_reason_label} title={language[lang].rejected_reason_label} data-bs-toggle="modal" data-bs-target={"#rejectedReasonModal_" + index} >
																										<i className="bi bi-pencil fs-4 px-2"></i>
																									</button>
																								</div>
																								
																							) : null 
																						}
																						<div className={"modal bg-light fade"} id={"rejectedReasonModal_" + index} tabIndex="-1" aria-labelledby={"rejectedReasonModalLabel_" + index} aria-hidden="true" >
																							<div className="modal-dialog modal-dialog-centered">
																								<div className="modal-content">
																									<div className="modal-header">
																										<h5 className="modal-title" id={"rejectedReasonModalLabel_" + index}>
																											{elem.trainee_name}
																										</h5>
																										<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																									</div>
																									<div className="modal-body">
																										<div className="mb-3">
																											<label htmlFor="message-text" className="col-form-label fw-bold">
																												{language[lang].rejected_reason_label}
																											</label>
																											<textarea className="form-control" id="message-text" rows={5} name="trainee_rejection_reason" data-index = { index } value={elem.trainee_rejection_reason !== undefined ? elem.trainee_rejection_reason : ''} onChange={handle_change_candidates}></textarea>
																										</div>
																									</div>
																									<div className="modal-footer">
																										<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{language[lang].close}</button>
																										<button type="button" data-bs-dismiss="modal" onClick={() => notifyCandidateAndSaveTrainee(elem.trainee_id, elem.trainee_name, elem.trainee_email, elem.trainee_status, elem.trainee_rejection_reason, index)} className={elem.trainee_notified !== undefined && elem.trainee_notified === true ? "btn btn-success" : "btn btn-primary"} >
																											<span>{elem.trainee_notified !== undefined && elem.trainee_notified === true ? language[lang].trainee_notified : language[lang].trainee_notify_button}</span>
																										</button>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div className='col-12 col-md-3'>
																					{
																						index === 0 ?
																							<label className='col-form-label fw-bold'>{language[lang].table_actions}</label>
																						:
																							null
																					}
																					<div className='d-flex align-items-center'>
																						<button type="button" alt={language[lang].trainee_notify_button} title={language[lang].trainee_notify_button} onClick={() => notifyCandidateAndSaveTrainee(elem.trainee_id, elem.trainee_name, elem.trainee_email, elem.trainee_status, elem.trainee_rejection_reason, index)} className={elem.trainee_notified !== undefined && elem.trainee_notified === true ? "btn btn-success" : "btn btn-primary"} >
																							<span>{elem.trainee_notified !== undefined && elem.trainee_notified === true ? language[lang].trainee_notified : language[lang].trainee_notify_button}</span>
																						</button>
																						{
																							('Administrador' === getTokenInfo().profile) ?
																								<button type="button" className = "ms-3 assec-btn-remove" onClick = {() => removeInputCandidate(index) }>
																									<img src ="./img/adicionar.svg" alt={language[lang].candidate_remove} title={language[lang].candidate_remove} />
																								</button>
																							:
																								null
																						}
																						<button
																							className='action d-none'
																							type="button" 
																							alt={language[lang].state_change_view}
																							title={language[lang].state_change_view}
																							data-bs-toggle="offcanvas" 
																							data-bs-target={"#offcanvasStatusInfoCandidate_"+ index}
																							aria-controls={"offcanvasStatusInfoCandidate_"+ index}
																							>
																								<i className="bi bi-person-gear fs-4 px-2"></i>
																								<span className="tooltiptext d-none">{language[lang].state_change_view}</span>
																						</button>
																					</div>
																				</div>
																			</div>
																			
																		</div>
																		
																	)
															})											
																
														) : <span className='fw-bold'>{language[lang].formation_registrations_empty}</span>
													}
												</div>

											</div>
										</div>
										<div className="tab-pane fade" id="users" role="tabpanel" aria-labelledby="users-tab">
											<div className="col-12 my-3">
												<div className="row">
													<div className='col-12 mt-3'>
														<h4 className="fw-bolder">{language[lang].trainees}</h4>
													</div>
													{ 
														data_trainees !== undefined && data_trainees.length > 0 ? (
																
															data_trainees.map( ( elem , index ) => {

																let aux_name = ''

																aux_name = elem.name + ' ' + elem.surname

																let trainee_exists_in_formation = false

																if(dados.current.content[0].trainees !== undefined && dados.current.content[0].trainees.length > 0){

																	trainee_exists_in_formation = dados.current.content[0].trainees.some(v => (v.trainee_id === elem.id));

																}
																//console.log(trainee_exists_in_formation)
																
																if(elem.id === '')
																	return ''
																else
																	return(
																		
																		<div  key = { `${index}` } className="col-12 mb-3">
																			<div className='row'>
																				<div className='col-12 col-md-3'>
																					{
																						index === 0 ?
																							<label className='col-form-label fw-bold'>{language[lang].name}</label>
																						:
																							null
																					}
																					<div className='input-group'>
																						<div className='input-group-text p-0'>
																							<Link
																								title={language[lang].profile_view}
																								alt={language[lang].profile_view}
																								to={{ 
																									pathname: '/trainee_view',
																									state: {
																										item: {id: elem.id},
																										operation: 'view',
																										backup_operation: 'profile_view',
																										formation_id: dados.current.id
																									},
																								}} >
																								<i className="bi bi-person-fill fs-4 px-2 text-primary"></i>
																							</Link>
																						</div>
																						<input
																							type="text" 
																							className = "form-control rounded-0"  
																							name ="trainee_name"  
																							value = { aux_name }
																							readOnly
																						/>
																					</div>
																				</div>
																				<div className='col-12 col-md-3'>
																					{
																						index === 0 ?
																							<label className='col-form-label fw-bold'>{language[lang].table_actions}</label>
																						:
																							null
																					}
																					<div className='d-flex align-items-center'>
																						<button type="button" alt={language[lang].add_trainee} title={language[lang].add_trainee} onClick={() => notifyAndSaveTrainee(elem.id, aux_name, elem.email)} className={trainee_exists_in_formation === true ? "btn btn-success" : "btn btn-primary"} >
																							<span>{trainee_exists_in_formation === true ? language[lang].trainee_added_and_notified : language[lang].add_trainee}</span>
																						</button>
																					</div>
																				</div>
																			</div>
																			
																		</div>
																		
																	)
															})											
																
														) : <span className='fw-bold'>{language[lang].formation_registrations_empty_2}</span>
													}
												</div>

											</div>
										</div>
									</div>
								</div>
							: 
								<div className="row mb-3" id="applicants">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].formation_registrations}</h3>
									</div>
									<div className="col-12 my-3">
										<div className="row">
											<div className='col-12 mt-3'>
												<h4 className="fw-bolder">{language[lang].candidates}</h4>
											</div>
											{ 
												dados.current.content[0].candidates !== undefined && dados.current.content[0].candidates.length > 0 ? (
														
													dados.current.content[0].candidates.map( ( elem , index ) => {

														if(elem.trainee_rejection_reason === undefined)
															elem.trainee_rejection_reason = ''
														
														if(elem.trainee_name === '')
															return ''
														else
															return(
																
																<div  key = { `${index}` } className="col-12 mb-3">
																	<div className='row'>
																		<div className='col-12 col-md-1 d-none'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold invisible'>{language[lang].profile}</label>
																				:
																					null
																			}
																			<div>
																				<Link 
																					className="btn btn-link"
																					to={{ 
																						pathname: '/trainee_view',
																						state: {
																							item: {id: elem.trainee_id},
																							operation: 'view',
																							backup_operation: 'profile_view',
																							formation_id: dados.current.id
																						},
																					}} >
																					<span>{language[lang].profile_view}</span>
																				</Link>
																			</div>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].name}</label>
																				:
																					null
																			}
																			<div className='input-group'>
																				<div className='input-group-text p-0'>
																					<Link
																						title={language[lang].profile_view}
																						alt={language[lang].profile_view}
																						to={{ 
																							pathname: '/trainee_view',
																							state: {
																								item: {id: elem.trainee_id},
																								operation: 'view',
																								backup_operation: 'profile_view',
																								formation_id: dados.current.id
																							},
																						}} >
																						<i className="bi bi-person-fill fs-4 px-2 text-primary"></i>
																					</Link>
																				</div>
																				<input
																					type="text" 
																					className = "form-control rounded-0"  
																					name ="trainee_name"  
																					value = { elem.trainee_name }
																					readOnly
																				/>
																			</div>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>
																						{language[lang].table_state}
																					</label>
																				:
																					null
																			}
																			<div className='input-group'>
																				{
																					elem.candidate_data !== undefined && elem.candidate_data.length > 0 ? (
																						<div className='input-group-text p-0'>
																							<button
																								className='action'
																								type="button" 
																								alt={language[lang].state_change_view}
																								title={language[lang].state_change_view}
																								data-bs-toggle="offcanvas" 
																								data-bs-target={"#offcanvasStatusInfoCandidate_"+ index}
																								aria-controls={"offcanvasStatusInfoCandidate_"+ index}
																								>
																									<i className="bi bi-person-gear fs-4 px-2"></i>
																									<span className="tooltiptext d-none">{language[lang].state_change_view}</span>
																							</button>
																						</div>
																					) : null 
																				}
																				<div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="true" tabIndex="-1" id={"offcanvasStatusInfoCandidate_"+ index} aria-labelledby={"offcanvasStatusInfoCandidate_" + index + "_Label"}>
																					<div className="offcanvas-header">
																						<h5 className="offcanvas-title" id={"offcanvasStatusInfoCandidate_" + index + "_Label"}>{elem.trainee_name}</h5>
																						<button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
																					</div>
																					<div className="offcanvas-body">

																						<div className='col-12 status-info'>
																							<h6 className='fw-bold'>{language[lang].state_change}</h6>

																							{ 
																								elem.candidate_data !== undefined && elem.candidate_data.length > 0 ? (

																									<div className="accordion border-0 mb-5" id="accordionDateStatus"> 

																										{
																											elem.candidate_data.map( ( elem2 , k ) => {

																												return(
																														<div key={k}>
																	
																															<div className="accordion-item mt-3">

																																<div className="accordion-header" id={'trainee-'+ index + '-heading-' + k}>
																																	<button className={"accordion-button collapsed"} type="button" data-bs-toggle="collapse" data-bs-target={'#trainee-'+ index + '-collapse-' + k} aria-expanded="true" aria-controls={'trainee-'+ index + '-collapse-' + k}>
																																		{
																																			elem2['date'] !== undefined && elem2.date !== '' ?
																																				<span>{elem2.date.split('T')[0]}</span>
																																			:
																																				<span>{language[lang].state_change_date_empty}</span>
																																		}
																																		{
																																			elem2.status !== undefined && elem2.status !== '' ?
																																				<span className={elem2.status === 'accepted' ? 'text-success': (elem2.status === 'rejected' ? 'text-danger' : 'text-warning')}>
																																					&nbsp;&#45;&nbsp;{language[lang][elem2.status]}
																																				</span>
																																			:
																																				null
																																		}
																																	</button>
																																</div>
																																<div id={'trainee-'+ index + '-collapse-' + k} className={"accordion-collapse collapse"} aria-labelledby={'trainee-'+ index + '-heading-' + k} data-bs-parent="#accordionDateStatus">
																																	<div className="accordion-body">

																																		{
																																			elem2.qualifications !== undefined && elem2.qualifications.name !== '' ?
																																				<div className='col-12 mb-3'>
																																					<label className='col-form-label fw-bold d-block'>
																																						{language[lang].state_change_educational_background}
																																						&#58;
																																					</label>
																																					<span>
																																						{elem2.qualifications.name}
																																					</span>
																																				</div>
																																			:
																																				null
																																		}

																																		{
																																			elem2.employment !== undefined && elem2.employment.employment_status !== '' ?
																																				<div className='col-12 mb-3'>
																																					<label className='col-form-label fw-bold d-block'>
																																						{language[lang].state_change_employment_status}
																																						&#58;
																																					</label>
																																					<span>
																																						{elem2.employment.employment_status}
																																					</span>
																																				</div>
																																			:
																																				null
																																		}

																																		{
																																			elem2.employment !== undefined && elem2.employment.employment_status === 'Empregado por conta de outrem' ?
																																			<div className="col-12">
																																				<div className="row">
																																					<div className='col-12 mb-3'>
																																						<label className='col-form-label fw-bold d-block'>
																																							{language[lang].state_change_employer_entity}
																																							&#58;
																																						</label>
																																						<span>
																																							{elem2.employment.employer_entity}
																																						</span>
																																					</div>
																																					<div className='col-12 mb-3'>
																																						<label className='col-form-label fw-bold d-block'>
																																							{language[lang].state_change_business_sector}
																																							&#58;
																																						</label>
																																						<span>
																																							{elem2.employment.business_sector}
																																						</span>
																																					</div>
																																					<div className='col-12 mb-3'>
																																						<label className='col-form-label fw-bold d-block'>
																																							{language[lang].state_change_employment_role}
																																							&#58;
																																						</label>
																																						<span>
																																							{elem2.employment.employment_role}
																																						</span>
																																					</div>
																																				</div>
																																			</div>
																																			:
																																				null
																																		}

																																		{ 

																																			elem2.files !== undefined && elem2.files.length > 0 ? (

																																				<div className='row'>
																																					<label className='col-form-label fw-bold d-block'>
																																						{language[lang].state_change_documents}
																																					</label>

																																					{

																																						elem2.files.map( ( v , f_index ) => {

																																							let aux_type = v.type

																																							if(aux_type === 'emprego-horario') {

																																								aux_type = 'emprego_horario'

																																							}

																																							if(v.link === '')
																																								return ''

																																							return (
																																									
																																								<div key = { `${f_index}` } className='col-12 mb-2'>
																																									<label className='col-form-label fw-bold d-block'>
																																										{language[lang]['state_change_doc_' + aux_type]}
																																									</label>
																																									<i className="bi bi-bookmark me-2"></i>
																																									<a href={v.link} alt={language[lang].file_view} title={language[lang].file_view} target='_blank' rel="noreferrer">
																																										{v.name}
																																									</a>
																																								</div>
																																							)

																																						})
																																					}
																																				</div>

																																			) : null
																																		}

																																	</div>
																																</div>
																															</div>
																														
																														</div>
																													
																												)

																											})
																										}
																									</div>


																								) : <span className='fw-bold'>{language[lang].state_change_empty}</span>
																							}
																							
																						</div>
																						<div className='col-12 mt-5'>
																							<button type="submit" form="form" className="btn btn-primary d-none">
																								<span>{language[lang].save}</span>
																							</button>
																							<button type="button" className="btn btn-secondary ms-2" data-bs-dismiss="offcanvas">{language[lang].close}</button>
																						</div>
																					</div>
																				</div>

																				{/*<Select
																					//className={"div-select " + (estado_selected.value === 'accepted' ? 'green' : '') + (estado_selected.value === 'accepted_change' ? 'yellow' : '') + (estado_selected.value === 'rejected' ? 'red' : '') + ((estado_selected.value === undefined || estado_selected.value === '' || estado_selected.value === 'under_review') ? 'gray' : '')}
																					options={ select_option_util_fun_2( [ {l: language[lang].accepted, v: 'accepted'} , {l: language[lang].accepted_change, v: 'accepted_change'}, {l: language[lang].rejected, v: 'rejected'} ] ) }
																					name="trainee_status"
																					value={(dados.current.info.reviewer_access[0] === undefined) ? null : { label: dados.current.info.reviewer_access[0].status, value: dados.current.info.reviewer_access[0].status }}
																					//value={estado_selected.value === '' ? null : { label: language[lang][estado_selected.value], value: estado_selected.value }}
																					//placeholder={language[lang].select_state_placholder}
																					onChange={handle_selected_estado}
																					styles={custom_select_styles_status}
																				/>*/}

																				<select className="form-select rounded-0" aria-label="Select Status" name='trainee_status' data-index = { index } data-trainee_id={elem.trainee_id} data-trainee_name={elem.trainee_name} data-trainee_email={elem.trainee_email} value={elem.trainee_status} onChange={handle_change_candidates}>
																					<option value="under_review">{language[lang].under_review}</option>
																					<option value="accepted">{language[lang].accepted}</option>
																					{/*<option value="accepted_change">{language[lang].accepted_change}</option>*/}
																					<option value="rejected">{language[lang].rejected}</option>
																				</select>
																				{ 
																					elem.trainee_status === 'rejected' ? (
																						<div className='input-group-text p-0'>
																							<button type="button" alt={language[lang].rejected_reason_label} title={language[lang].rejected_reason_label} data-bs-toggle="modal" data-bs-target={"#rejectedReasonModal_" + index} >
																								<i className="bi bi-pencil fs-4 px-2"></i>
																							</button>
																						</div>
																						
																					) : null 
																				}
																				<div className={"modal bg-light fade"} id={"rejectedReasonModal_" + index} tabIndex="-1" aria-labelledby={"rejectedReasonModalLabel_" + index} aria-hidden="true" >
																					<div className="modal-dialog modal-dialog-centered">
																						<div className="modal-content">
																							<div className="modal-header">
																								<h5 className="modal-title" id={"rejectedReasonModalLabel_" + index}>
																									{elem.trainee_name}
																								</h5>
																								<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
																							</div>
																							<div className="modal-body">
																								<div className="mb-3">
																									<label htmlFor="message-text" className="col-form-label fw-bold">
																										{language[lang].rejected_reason_label}
																									</label>
																									<textarea className="form-control" id="message-text" rows={5} name="trainee_rejection_reason" data-index = { index } value={elem.trainee_rejection_reason !== undefined ? elem.trainee_rejection_reason : ''} onChange={handle_change_candidates}></textarea>
																								</div>
																							</div>
																							<div className="modal-footer">
																								<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{language[lang].close}</button>
																								<button type="button" data-bs-dismiss="modal" onClick={() => notifyCandidateAndSaveTrainee(elem.trainee_id, elem.trainee_name, elem.trainee_email, elem.trainee_status, elem.trainee_rejection_reason, index)} className={elem.trainee_notified !== undefined && elem.trainee_notified === true ? "btn btn-success" : "btn btn-primary"} >
																									<span>{elem.trainee_notified !== undefined && elem.trainee_notified === true ? language[lang].trainee_notified : language[lang].trainee_notify_button}</span>
																								</button>
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].table_actions}</label>
																				:
																					null
																			}
																			<div className='d-flex align-items-center'>
																				<button type="button" alt={language[lang].trainee_notify_button} title={language[lang].trainee_notify_button} onClick={() => notifyCandidateAndSaveTrainee(elem.trainee_id, elem.trainee_name, elem.trainee_email, elem.trainee_status, elem.trainee_rejection_reason, index)} className={elem.trainee_notified !== undefined && elem.trainee_notified === true ? "btn btn-success" : "btn btn-primary"} >
																					<span>{elem.trainee_notified !== undefined && elem.trainee_notified === true ? language[lang].trainee_notified : language[lang].trainee_notify_button}</span>
																				</button>
																				{
																					('Administrador' === getTokenInfo().profile) ?
																						<button type="button" className = "ms-3 assec-btn-remove" onClick = {() => removeInputCandidate(index) }>
																							<img src ="./img/adicionar.svg" alt={language[lang].candidate_remove} title={language[lang].candidate_remove} />
																						</button>
																					:
																						null
																				}
																				<button
																					className='action d-none'
																					type="button" 
																					alt={language[lang].state_change_view}
																					title={language[lang].state_change_view}
																					data-bs-toggle="offcanvas" 
																					data-bs-target={"#offcanvasStatusInfoCandidate_"+ index}
																					aria-controls={"offcanvasStatusInfoCandidate_"+ index}
																					>
																						<i className="bi bi-person-gear fs-4 px-2"></i>
																						<span className="tooltiptext d-none">{language[lang].state_change_view}</span>
																				</button>
																			</div>
																		</div>
																	</div>
																	
																</div>
																
															)
													})											
														
												) : <span className='fw-bold'>{language[lang].formation_registrations_empty}</span>
											}
										</div>

									</div>
								</div>
						}

						{
							//formation trainees
							is_edit === true /*&& add_trainers_permission*/ ?

								<div className="row mb-3" id="trainees">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].trainees}</h3>
									</div>
									<div className="col-12 my-3">
										<div className="row">
											<div className='col-12 mt-3'>
												<h4 className="fw-bolder">{language[lang].trainee}</h4>
											</div>
											{ 
												dados.current.content[0].trainees !== undefined && dados.current.content[0].trainees.length > 0 ? (
														
													dados.current.content[0].trainees.map( ( elem , index ) => {

														//console.log('formandos: ', elem)
														
														if(elem.trainee_name === '')
															return ''
														else
															return(
																
																<div  key = { `${index}` } className="col-12 mb-3">
																	<div className='row'>
																		<div className='col-12 col-md-1 d-none'>
																			<label className='col-form-label fw-bold invisible'>{language[lang].profile}</label>
																			<div>
																				<Link 
																					className="btn btn-link"
																					to={{ 
																						pathname: '/trainee_view',
																						state: {
																							item: {id: elem.trainee_id},
																							operation: 'view',
																							backup_operation: 'profile_view',
																							formation_id: dados.current.id
																						},
																					}} >
																					<span>{language[lang].profile_view}</span>
																				</Link>
																			</div>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].name}</label>
																				:
																					null
																			}
																			<div className='input-group'>
																				{
																					('Administrador' === getTokenInfo().profile) ?
																						<button type="button" className = "me-3 assec-btn-remove" onClick = {() => removeInputTrainee(index, elem.trainee_id) } >
																							<img src ="./img/adicionar.svg" alt={language[lang].trainee_remove} title={language[lang].trainee_remove} />
																						</button>
																					:
																						null
																				}
																				<div className='input-group-text p-0'>
																					<Link
																						title={language[lang].profile_view}
																						alt={language[lang].profile_view}
																						to={{ 
																							pathname: '/trainee_view',
																							state: {
																								item: {id: elem.trainee_id},
																								operation: 'view',
																								backup_operation: 'profile_view',
																								formation_id: dados.current.id
																							},
																						}} >
																						<i className="bi bi-person-fill fs-4 px-2 text-primary"></i>
																					</Link>
																				</div>
																				<input
																					type="text" 
																					className = "form-control rounded-0"  
																					name ="trainee_name"  
																					value = { elem.trainee_name }
																					readOnly
																				/>
																			</div>
																		</div>
																		<div className='col-12 col-md-3 d-none'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>Email</label>
																				:
																					null
																			}
																			<input
																				type="text" 
																				className = "form-control rounded-0"  
																				name ="trainee_email"  
																				value = { elem.trainee_email }
																				readOnly
																			/>
																		</div>
																		<div className='col-12 col-md-3'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>
																						{language[lang].table_state}
																					</label>
																				:
																					null
																			}
																			<div className='input-group'>
																				<select className="form-select rounded-0" aria-label="Select Status" name='trainee_status' data-index = { index } data-trainee_id={elem.trainee_id} data-trainee_name={elem.trainee_name} value={elem.trainee_status !== '' ? elem.trainee_status : '---'} onChange={handle_change_trainees}>
																					<option value="---">---</option>
																					<option value="quitter">{language[lang].quitter}</option>
																					<option value="accepted">{language[lang].accepted}</option>
																					<option value="flunked">{language[lang].flunked}</option>
																				</select>
																			</div>
																		</div>
																		<div className='col-12 col-md-2'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold'>{language[lang].final_evaluation}</label>
																				:
																					null
																			}
																			<input
																				type="text" 
																				className = "form-control rounded-0"  
																				name ="trainee_final_evaluation"  
																				data-index = { index }
																				value = { elem.trainee_final_evaluation !== undefined ? elem.trainee_final_evaluation : '' }
																				onChange={handle_change_trainees}
																			/>
																		</div>
																		<div className="div-form-input col-12 col-md-4">
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold d-block'>{language[lang].certificate}</label>
																				:
																					null
																			}
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2" htmlFor={"input-files-pdf-" + elem.trainee_id}>{language[lang].doc_choose}</label>
																			<input
																				id={"input-files-pdf-" + elem.trainee_id}
																				type="file"
																				accept=".pdf"
																				data-order={'0'}
																				data-uid={elem.trainee_id}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesDoc}
																				multiple
																			/>
																			{
																			files_doc_name[elem.trainee_id] !== undefined ?
																				<span>{files_doc_name[elem.trainee_id].name}</span>
																			:
																				elem['files'] !== undefined && elem['files'].length > 0 ?
																					<>
																						<a href={elem['files'][0].link} alt={language[lang].file_view} title={language[lang].file_view} target='_blank' rel="noreferrer">
																							<i className="bi bi-file-arrow-down fs-4 px-2"></i>
																						</a>
																						<button type="button" className='d-inline-flex align-items-center' onClick={() => removeCertificateFile('0', elem.trainee_id)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																							<i className="bi bi-x fs-4 pe-1"></i>
																							<span>{language[lang].file_remove}</span>
																						</button>
																					</>
																				:
																					null
																			}
																		</div>
																		<div className='col-12 col-md-1 d-none'>
																			{
																				index === 0 ?
																					<label className='col-form-label fw-bold d-block invisible'>{language[lang].table_actions}</label>
																				:
																					null
																			}
																			{/*<button type="button" onClick={() => notifyCandidateAndSaveTrainee(elem.trainee_id, elem.trainee_name, elem.trainee_email, elem.trainee_status, index)} className={elem.trainee_notified !== undefined && elem.trainee_notified === true ? "btn btn-success" : "btn btn-warning"} >
																				<span>{elem.trainee_notified !== undefined && elem.trainee_notified === true ? language[lang].trainee_notified : language[lang].trainee_notify_button}</span>
																			</button>*/}
																			<button type="button" className = "ms-3 assec-btn-remove" onClick = {() => removeInputTrainee(index, elem.trainee_id) } >
																				<img src ="./img/adicionar.svg" alt={language[lang].trainee_remove} title={language[lang].trainee_remove} />
																			</button>
																		</div>
																	</div>
																	
																</div>
																
															)
													})											
														
												) : <span className='fw-bold'>{language[lang].trainees_empty}</span>
											}
										</div>

									</div>
								</div>
							: ''
						}
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">

								{
									props.location.state !== undefined && props.location.state.return_button_endpoint === 'list2' ? (
										<li className='nav-item'>
											<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list2 }}  >
												<img alt={language[lang].back} src={'./img/seta_2.svg'} />
												<span>{language[lang].back}</span>
											</Link>

										</li>
									) : 

										props.location.state !== undefined && props.location.state.go_back_operation === 'main_view' ? (
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: Main.view.endpoint}}  >
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li> 
										) :
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
													{/*<img alt='' src={'./img/cancelar.svg'} />
													<span>{language[lang].cancel}</span>*/}
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li> 
								}
								{/*<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>*/}
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>
		</main>

}
